import { render, staticRenderFns } from "./ApprovedInspectionsList.vue?vue&type=template&id=67b55c61&"
import script from "./ApprovedInspectionsList.vue?vue&type=script&lang=js&"
export * from "./ApprovedInspectionsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports